// extracted by mini-css-extract-plugin
export default {"componentWrapper":"GridSwitcher_componentWrapper__rx5+a","gridIcon":"GridSwitcher_gridIcon__RiHze","active":"GridSwitcher_active__6qJRR","name":"GridSwitcher_name__shq7x"};